import { KeyDate } from "@models/keyDate.model";
import { httpRequest } from "../../http";

export class CommandCreateKeyDate {
    async run(engagementId: number, objectiveId: number, keyDate: KeyDate) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/objectives/${objectiveId}/key-dates/`
        const body = keyDate
        try {
            const response = await httpRequest<any>(url, { method: "POST", body });
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            console.log(body)
            throw error;
        }
    }
}

